import React from "react";

const Stage0 = (props) => {
  return <div>Stage 0</div>;
};

export default Stage0;
